import { render, staticRenderFns } from "./MemberBody.vue?vue&type=template&id=0a3adee0&scoped=true&"
import script from "./MemberBody.vue?vue&type=script&lang=ts&"
export * from "./MemberBody.vue?vue&type=script&lang=ts&"
import style0 from "./MemberBody.vue?vue&type=style&index=0&id=0a3adee0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3adee0",
  null
  
)

export default component.exports